var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanetVenus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 623.75 623.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#c06d29;filter:url(#outer-glow-6);}.cls-4{fill:#f3c24e;}.cls-5{fill:#6e2e14;}.cls-6{isolation:isolate;}.cls-7{fill:#fff;mix-blend-mode:overlay;opacity:.5;}.cls-8{fill:#722d15;opacity:.35;}"), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c06d2a",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 311.87,
    cy: 311.87,
    r: 252
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 311.87,
    cy: 311.87,
    r: 252
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 469.8,
    cy: 244.59,
    r: 30.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 200.09,
    cy: 229.01,
    r: 41.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 376.68,
    cy: 388.01,
    r: 55.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M363.66,301.31c-15.75,16.6-26.57,28.01-45.38,36.98-29.35,13.99-75.01,20.53-110.94,0-38.08-21.76-34.71-56.51-72.28-67.23-2.92-.83-28.18-7.66-50.43,5.04-34,19.41-41.2,73.17-28.57,110.94,16.96,50.76,73.54,84.08,114.3,75.64,33.43-6.93,38.01-38.18,82.36-47.06,30.76-6.16,36.4,7.31,60.51,0,47.61-14.43,47.95-73.72,79-77.32,37.3-4.32,56.2,78.98,102.53,79,35.84,.02,61.01-49.81,63.87-55.47,39.36-77.9-6.55-194.74-55.47-201.7-25.62-3.65-50.93,23-70.6,43.7-32.51,34.22-30.28,56.76-68.91,97.49Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 362.64,
    cy: 145.21,
    r: 31.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M503.2,147.88c75.95,89.17,67.33,223.15-20.4,301.78-89.11,79.88-226.11,72.4-306-16.71-79.88-89.11-72.4-226.11,16.71-306,87.72-78.63,221.84-72.61,302.21,12.6-93.39-99.72-249.82-106.97-352.07-15.32-103.63,92.9-112.34,252.22-19.44,355.85,92.9,103.63,252.22,112.34,355.85,19.44,102.24-91.65,112.08-247.94,23.12-351.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 367.06,
    cy: 256.18,
    r: 163.96
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetVenus);
export default __webpack_public_path__ + "static/media/Planet_Venus.b8a7de593ed61d80ba1086552f68e2af.svg";
export { ForwardRef as ReactComponent };